module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAwUlEQVQokX3PPQrCQBCG4TewXfAEVsIi+NOqbQ6TY+UeluYONgoptREVRMUQi8/CJC5xNx9sM7PPziySjKSFpIEkes5A0kqSQdJc3xwk2QCwdV+SZtGjUgzsgSFwBBKg4BcL5E5/HB0f8jUa6K1H24tCL6ZA5tsg2hxa1IVN/lY2p5drKOoJa6eWdv74h2y9kpusb1Lfn3IXmnPpBc2FxKm30FxL4gAgAMfmVjEKAAJwZJ5vdsAS2AF3/CmACTAF9h9qAp25klrQXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/pumpMonitor/pmap/close.png
// module id = pB67
// module chunks = 157